import { colors } from '../constants/colors';
import { DEAL_STATUS_FAILED, DEAL_STATUS_REJECTED } from '../constants';
import { DEAL_STATUS_TTL_EXPIRED } from '../constants/dealStatuses';

const FAILED_DEAL_STATUSES = [DEAL_STATUS_FAILED, DEAL_STATUS_REJECTED, DEAL_STATUS_TTL_EXPIRED];

/**
 * Ð¦Ð²ÐµÑ Ð±ÐµÐ¹Ð´Ð¶Ð° ÑÐ´ÐµÐ»ÐºÐ¸ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð»Ð¸Ð´Ð¾Ð² (ÐºÐ¾Ð»Ð¾Ð½ÐºÐ° Â«Ð¡Ð´ÐµÐ»ÐºÐ°Â»).
 *
 * ÐÐµÐ»ÑÐ½ÑÐ¹ â Ð¿Ð¾ ÑÐ°ÐºÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ (dealStatus.bankApproved, Ð±ÑÐºÐµÐ½Ð´ Ð±ÐµÑÑÑ ÐµÐ³Ð¾ Ð¸Ð· Ð·Ð°ÑÐ²Ð¾Ðº),
 * Ð° Ð½Ðµ Ð¿Ð¾ ÑÑÐ°ÑÑÑÑ Â«ÐÑÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°Â»: ÑÑÐ°ÑÑÑ Ñ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¾Ð´Ð¸Ð½ Ð¸ ÑÑÐ¾Ð´Ð¸Ñ Ð´Ð°Ð»ÑÑÐµ
 * (Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ, Ð·Ð°Ð»Ð¾Ð³, Ð²ÑÐ´Ð°ÑÐ°), Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÑÐ¶Ð½Ð¾ Ð²Ð¸Ð´ÐµÑÑ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð¾Ð´Ð¾Ð±ÑÐ¸Ð»Ð¸ Ð¸Ð»Ð¸ Ð½ÐµÑ.
 */
const leadDealStatusColor = (dealStatus) => {
  if (FAILED_DEAL_STATUSES.includes(dealStatus?.id)) return colors.red;
  return dealStatus?.bankApproved ? colors.green : colors.dimGray;
};

export default leadDealStatusColor;
